export default __webpack_public_path__ + "static/underwearHeader-995e1b9e13f7e08775233f2cfd0a02f0.jpg";